module.exports = ".prueba {\n  color: red !important; }\n  .prueba a {\n    color: red !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/data-table/data-table.component.scss
// module id = ./src/app/examples/data-table/data-table.component.scss
// module chunks = main